import React, { useState } from 'react'
import { Box, Grid, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions } from '@material-ui/core'
import { HeaderBlock } from '../../components/header-block/HeaderBlock'
import Search from '../../components/search/Search'
import { Loading } from '../../components/loading/Loading'
import PageContainer from '../../components/page-container/PageContainer'
import SimpleTable from '../../components/table/Table'
import { PagePlaceholder } from '../../components/page-placeholder/PagePlaceholder'
import { getIcon } from '../../icon/icon'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { getUserRoles, upsertUserRole } from '../../state/actions/UserRoleActions'
import { useTranslation } from 'react-i18next'

function ListUserRolesPage(props) {
    const userRoles = useSelector(state => state.UserRoleReducer.userRoles)

    const dispatch = useDispatch()
    const [t, i18n] = useTranslation()

    const [loading, setLoading] = useState(false)
    const [searchedData, setSearchedData] = useState([])
    const [originalData, setOriginalData] = useState([])
    const [newRole, setNewRole] = useState(null)
    const [newRoleDialogOpen, setNewRoleDialogOpen] = useState(false)
    const [error, setError] = useState(null)
    const [fetchRoles, setFetchRoles] = useState(true)

    useEffect(() => {
        if (fetchRoles) {
            setLoading(true)
            dispatch(getUserRoles(() => {
                setLoading(false)
                setFetchRoles(false)
            }))
        }
    }, [fetchRoles])

    useEffect(() => {
        setSearchedData(createData(userRoles))
        setOriginalData(createData(userRoles))
    }, [userRoles])

    function handleAddRole() {
        if (newRole != null) {
            dispatch(upsertUserRole(newRole, null, () => {
                setNewRoleDialogOpen(false)
                setNewRole(null)
                setFetchRoles(true)
            }))
        } else {
            setError(t("user-role.must-have-name"))
        }
    }

    function createData(roles) {
        if (roles != null) {
            const userRolesKeys = Object.keys(roles)

            return userRolesKeys.map(userRolesKey => {
                const role = roles[userRolesKey]

                if (role != true) {
                    return {
                        id: role.id,
                        name: role.displayName,
                    }
                } else {
                    return {}
                }
            })
        } else {
            return []
        }
    }

    function createHeaders() {
        return [
            {
                id: "name",
                clickable: true,
                align: "left",
                label: t("common.name"),
                type: "label"
            },
            {
                id: "id",
                clickable: false,
                align: "left",
                label: t("common.id"),
                type: "label"
            }
        ];
    }

    function createCells(headers) {
        let cells = [];

        headers.forEach(header => {
            let cell = {};

            cell.id = header.id;

            cell.handleClick = (event, row) => {
                props.history.push(`/user-roles/${row.id}`);
            };

            cell.align = header.align;
            cell.clickable = header.clickable;
            cell.type = header.type;

            cells.push(cell);
        });

        return cells;
    }



    function renderTable() {
        const headers = createHeaders();
        const cells = createCells(headers);

        if (searchedData.length > 0) {
            return (
                <SimpleTable
                    isSelectable={false}
                    dataId={"id"}
                    cells={cells}
                    headers={headers}
                    rows={searchedData}
                />
            );
        } else {
            return (
                <PagePlaceholder
                    image={getIcon("checkbox.svg")}
                    text={t("user-role.no-roles")}
                />
            );
        }
    }

    function renderNewRoleDialog() {
        return (
            <Dialog open={newRoleDialogOpen} fullWidth>
                <DialogTitle > New User Role </DialogTitle>
                <DialogContent>
                    <TextField
                        label={t("user-role.role-name")}
                        value={newRole}
                        variant="outlined"
                        fullWidth
                        margin="dense"
                        onChange={(event) => setNewRole(event.target.value != "" ? event.target.value : null)}
                        error={error}
                        helperText={error}
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => {
                            setNewRole(null)
                            setNewRoleDialogOpen(false)
                        }}
                    >
                        {t("common.cancel")}
                    </Button>
                    <Button
                        variant="outlined"
                        color="secondary"
                        onClick={() => handleAddRole()}
                    >
                        {t("common.save")}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <Box>
            <HeaderBlock
                title={t('user-role.user-roles')}
                right={
                    <Grid container spacing={2} alignItems="center" justify="flex-end">

                        <Grid item>
                            <Search
                                searchField={"name"}
                                secondaryFields={["id"]}
                                returnSearchMatches={data => {
                                    setSearchedData(data)
                                }}
                                data={originalData}
                                searchTitle={t("user-role.search-roles")}
                            />
                        </Grid>
                        <Grid item>
                            <Button
                                color="secondary"
                                variant="outlined"
                                onClick={() => setNewRoleDialogOpen(true)}

                            >
                                {t("user-role.add")}
                                </Button>
                        </Grid>
                    </Grid>
                }
            />

            {renderNewRoleDialog()}

            <PageContainer hasFooter>
                {loading ? <Loading /> : renderTable()}
            </PageContainer>
        </Box>
    )
}


export default ListUserRolesPage

